import Logo from 'images/logo_wh.png';
import React from 'react';
import { Menu, Sidebar as ProSidebar } from 'react-pro-sidebar';

type Props = {
  children: React.ReactNode;
};

export const Sidebar = ({ children }: Props) => {
  return (
    <ProSidebar className="drawer" breakPoint="xs">
      <div className="pro-sidebar-header">
        <div className="toolbar">
          <img
            src={Logo}
            alt="reprua-logo"
            style={{ width: '100%', objectFit: 'contain', paddingRight: 40, paddingLeft: 40 }}
          />
        </div>
      </div>
      <Menu>{children}</Menu>
    </ProSidebar>
  );
};
